/**
 * LangSwitcher Class
 * @class LangSwitcher
 */

export default class LangSwitcher {

    constructor() {
        let elements = document.querySelectorAll('.block-languageblock');
        if (elements.length) {
            elements.forEach(element => {
                element.innerHTML = `<svg class="lang-switcher__arrow" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.48474 5.24255L5.24219 2L1.99963 5.24255" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>` + element.innerHTML;
            });
        }
        this.list = document.querySelector('.lang-switcher__wrapper');
        this.arrow = document.querySelector('.lang-switcher__arrow');
        this.loadEvents();
    }

    loadEvents() {
        if (this.list) {
            this.list.addEventListener('click', () => {
                this.toggleSwitcher();
            });

            this.list.querySelector('.active').addEventListener('click', (event) => {
                event.preventDefault();
            });
        }
        if (this.arrow) {
            this.arrow.addEventListener('click', () => {
                this.toggleSwitcher();
            });
        }


    }

    toggleSwitcher() {
        if (this.list.classList.contains('open')) {
            this.list.classList.remove('open');
            this.arrow.classList.remove('open');
        } else {
            this.list.classList.add('open');
            this.arrow.classList.add('open');
        }
    }
}
